var RoxInsuranceOverlay = function(){
	this.RIOverlay = $("#D_EYEMED_OVERLAY");
  this.showOverlayLink = $(".Apply-benefits-link");
  this.sourceHTML = "";
  this.isRoxInsEnabled = $("#isROXInsEnabled") && $("#isROXInsEnabled").length > 0 && $("#isROXInsEnabled").val() === "true" ? true : false;

    
  this.init = function(){
        if(this.isRoxInsEnabled){
          if($("#pageTypeIns") && $("#pageTypeIns").val() === "ShopCart") this.check4MultipleItemsInCart();
          this.populateDOBSelects();
          this.bindEvent();
        }
  };
    
	this.bindEvent = function(){
		    var self = this;
        $(".Apply-benefits-link").off("click").on("click", {"self": self}, this.showOverlay);
        //$(document).on(".Apply-benefits-link","click",{"self": self}, this.showOverlay);
        $(".eyemed-submit-button-registration-form").off("click").on("click", { "self": self }, this.submitEyemedForms);
        $(".eyemed-submit-button-login-form").off("click").on("click", { "self": self }, this.submitEyemedForms);
        $(".form-wrapper input").on("keyup blur",{"self": self}, this.showActiveForm);
        $(".form-wrapper select").off("change").on("change",{"self": self}, this.showActiveForm);
        $("#eyemed_benefit_registration_form, #eyemed_benefit_login_form").off("submit").on("submit",function(e){e.preventDefault();});
        $(".eyemed-benefits-overlay .wcs-close-btn").off("click").on("click", this.reloadPage);
        $(".inactive-form .fadeout-full").off("click").on("click", this.enableForm);
        $(".wcs-button-checkout, .paypal-disable-wrapper").off("click").on("click",{"self": self}, this.scrollToBenefitError);
        var pagename = $("#pageNameVal").val();
        if(pagename === 'ShopCart' ) {
        	$("#wcs-apply-pay").off("click").on("click",{"self": self}, this.scrollToBenefitError);
        }
	};
	this.showOverlay = function(e){
  		  var self = e.data.self;
  		  if(self.sourceHTML !== ""){
  			/***Redraw overlay to remove previous error messages***/
             self.redrawOverlay();
  	    }
  	    else self.sourceHTML = document.getElementById("D_EYEMED_OVERLAY").innerHTML;

        $("#eyemed_benefit_registration_form #month, #eyemed_benefit_registration_form #day, #eyemed_benefit_registration_form #year").on("click",function(e){
            e.preventDefault();
            return false;
        });
        
        /******If not logged in to eyemed and cart has more than 1 item*********/
        if($("#pageTypeIns") && $("#pageTypeIns").val() === "ShopCart"){
        	var qty = self.getCartQuantityCount();
		    
  		    if(qty > 1){
  		        $("#benefits-limit-error").removeClass("wcs-hide").removeClass("wcs-hidden");
              $('html,body').animate({
                scrollTop: $("#benefits-limit-error").offset().top
              },'slow');
  		        return true;
  		    }
        }
        /*********If already logged in*********/
        if($.cookie('EyeMedLogin') && $.cookie('EyeMedLogin') === "true"){
           self.hideAndShowWrappers("applied");
           return;
        }
        else self.hideAndShowWrappers("load");
      //   window.display_center_1(self.RIOverlay);
    		// window.show_full_fadeout_1();
    		// self.RIOverlay.show().removeClass("wcs-hidden").removeClass("wcs-hide");
    		// load_scroller();
	     //  expand_dropbox();
		
	};
	this.redrawOverlay = function(){
      document.getElementById("D_EYEMED_OVERLAY").innerHTML="";
		  document.getElementById("D_EYEMED_OVERLAY").innerHTML= this.sourceHTML;
		  this.bindEvent();
		  var eyemedForms = $(".form-wrapper form");
		  window.validateForms(eyemedForms);
	};
	this.populateDOBSelects = function(){
		  for(var i=1; i<=12; i++){
		     $("#month").append("<option value='"+i+"'>"+i+"</option>");
	    }
      /***Populate days select box*****/
      for(var j=1; j<=31; j++){
		     $("#day").append("<option value='"+j+"'>"+j+"</option>");
	    }
	    var d = new Date();
  		for(var k=1900; k<= d.getFullYear(); k++){
  		     $("#year").append("<option value='"+k+"'>"+k+"</option>");
  		}
	};
	this.hideAndShowWrappers = function(status, data){
      if(status !== "serverFormError") {
         $(".eyemed-benefits-overlay .wcs-close-btn").trigger("click");
       }
      
  	  switch (status){
  	  	  case "success":
  	  	     $(".eyemed-overlay-sub-header,.eyemed-form-wrapper").addClass("wcs-hide");
  		       $(".server-error-message").addClass("wcs-hidden");
             $(".success-message-wrapper").removeClass("wcs-hide");
             $(".eyemed-benefits-overlay").css("width","667px");
             break;
          case "serverFormError":
             var errorMsg = data.hasOwnProperty("ErrorMessage") ? data.ErrorMessage : "Your current EyeMed Plan is not compatible with Ray-Ban.com purchases. Exit to continue shopping without EyeMed Insurance.";  
             $(".server-error-message").removeClass("wcs-hidden").find(".wcs-note-red div").text(errorMsg);
             break;
          case "somethingWrongError":
             $(".eyemed-overlay-sub-header,.eyemed-form-wrapper").addClass("wcs-hide");
             $(".error-main-wrapper").removeClass("wcs-hide");
             $(".eyemed-benefits-overlay").css("width","667px");
             break;
          case "applied":
             $(".eyemed-overlay-sub-header,.eyemed-form-wrapper,.success-message-wrapper,.error-main-wrapper").addClass("wcs-hide");
             $(".benefits-applied-wrapper").removeClass("wcs-hide");
             $(".eyemed-benefits-overlay").css("width","667px");
             break;
          default:
             $(".eyemed-benefits-overlay").css("width","887px");
  	  }
      
      if(status === "serverFormError"){
        $('html,body').animate({
           scrollTop: $(".server-error-message").offset().top
        },'slow');
      }
      else{
        window.display_center_1(this.RIOverlay);
        window.show_full_fadeout_1();
        this.RIOverlay.show().removeClass("wcs-hidden").removeClass("wcs-hide");
        load_scroller();
        expand_dropbox();
        this.bindEvent();
      }
	};
  
  

	this.showActiveForm = function(e){
      var self = e.data.self;
      var elem = e.currentTarget;
      var activeFormWrapper = $(e.currentTarget).closest(".form-wrapper");
      var isFormEmpty = false;

      if(($(elem).attr("id") == "zip" && $("#zip").val() === "" && $("#ssn").val() === "") || ($(elem).attr("id") == "ssn" && $("#ssn").val() === "" && $("#zip").val() === "")) {
        $("#zip").attr("required","true");
        $("#ssn").attr("required","true");
      }

      $(".form-wrapper").removeClass("active-form").removeClass("inactive-form");

      if($(elem).val() !== ""){
           $(elem).closest(".form-wrapper").addClass("active-form");
      }
      else{
      	var emptyFields = 0;
      	$(activeFormWrapper).find("input, select").each(function(i, obj){
             if($(obj).val() === "") emptyFields++;
      	});
      	if(emptyFields !== $(activeFormWrapper).find("input, select").length -1) {
          $(elem).closest(".form-wrapper").addClass("active-form");
        }
        else{
          isFormEmpty = true;
        }
      }

      $(".form-wrapper").each(function(j, formWrapper){
        	if(!$(this).hasClass("active-form") && $(activeFormWrapper).attr("id") !== $(formWrapper).attr("id")) {
	             var emptyFieldCount = 0;
  	        	 $(this).find("input, select").each(function(i,obj){
  	        	 	if($(obj).val() === "") emptyFieldCount++;
  	        	 });

               if(isFormEmpty && emptyFieldCount === $(this).find("input, select").length -1){
                  return;
               }

	           	 if(emptyFieldCount === $(this).find("input, select").length -1){
	           	 	$(this).addClass("inactive-form");
	           	 	$(".inactive-form .fadeout-full").off("click").on("click", self.enableForm);
	           	 	self.hideErrors(this);
	           	 }
	           	 else if(emptyFieldCount !== $(this).find("input, select").length -1){
	                $(this).addClass("active-form");
	           	 }
            }     
	    });
	};
	this.enableForm = function(e){
		var clickedElem = e.currentTarget;
		$(clickedElem).closest(".form-wrapper").removeClass("inactive-form");//.find(".fadeout-full").hide();
	};
	this.hideErrors = function(formWrapper){
       $(formWrapper).find("input, select").each(function(i, obj){
           window.hide_error($(obj));
       });
	};
	this.submitEyemedForms = function(e){
        var self = e.data.self;
        var isRegFormValid = false, isLoginFormValid = false;
        
        /****If no form is active then return ****/

        if($(".form-wrapper.active-form").length === 0){
        	return false;
        } 
        else{
        	/****Validate forms  and store the value, if it is active***/
            if($("#eyemed_benefit_registration_form").closest(".form-wrapper").hasClass("active-form")){
               isRegFormValid = $('#eyemed_benefit_registration_form').h5Validate('allValid');
            }
            if($("#eyemed_benefit_login_form").closest(".form-wrapper").hasClass("active-form")){
               isLoginFormValid = $('#eyemed_benefit_login_form').h5Validate('allValid');
            }
        }
    

		var regPostparams = {}, loginPostParams = {}, postParams = {};

		if( $("#eyemed_benefit_registration_form").closest(".form-wrapper").hasClass("active-form") && isRegFormValid){
			var dobStr="";
            $("#eyemed_benefit_registration_form input,#eyemed_benefit_registration_form select").each(function(){
            	var name = $(this).attr('name');
            	 if(name !== "day" && name !== "month" && name !== "year"){
                    regPostparams[name] = $(this).val();
                    postParams[name] = $(this).val();
            	 }
            });
            var monthVal = $("#month").val().length === 1 ? "0"+$("#month").val():$("#month").val();
            var dayVal = $("#day").val().length === 1 ? "0"+$("#day").val():$("#day").val();
            regPostparams.dateOfBirth = $("#year").val()+"-"+ monthVal +"-"+dayVal;
		}

		if($("#eyemed_benefit_login_form").closest(".form-wrapper").hasClass("active-form") && isLoginFormValid){
            $("#eyemed_benefit_login_form input").each(function(){
                 var name = $(this).attr('name');
                 loginPostParams[name] = $(this).val();
                 postParams[name] = $(this).val();
            });
           
		}


      if(isLoginFormValid && isRegFormValid){
         self.submitHandler(postParams, self);
      }
	    else if(isLoginFormValid){
	    	self.submitHandler(loginPostParams, self);
	    }
	    else if(isRegFormValid){
	    	self.submitHandler(regPostparams, self);
	    }
	    else{
	    	return false;
	    }
	};

	this.submitHandler = function(postparams, self){
		  if($("#pageTypeIns") && $("#pageTypeIns").length !== 0){
			  postparams.pageTypeIns = $("#pageTypeIns").val();
		  }else if($("#isRoxEnabled").length > 0 && $("#isRoxEnabled").val() == "true"){
			  postparams.pageTypeIns = "PDP";
		  }
		  if($("#OrderId") && $("#OrderId").length !== 0) postparams.orderId = $("#OrderId").val();
		  if($("#pdpFrameCatId") && $("#pdpFrameCatId").length !== 0) {
		  	postparams.roxFrameCatentryId = $("#pdpFrameCatId").val();
		  	postparams.roxLensCatentryId = typeof pdpRoxInst !== "undefined"? pdpRoxInst.selectedProductData.catentryId : window.selectedProductData.catentryId;
		  }

      if (window.Rayban && window.Rayban.rcInstance && !!window.Rayban.rcInstance.selectedLensesId) {
        window.pdpRoxInst = typeof pdpRox !== 'undefined'? new pdpRox() : undefined;
        postparams.pageTypeIns = "PDP";
        postparams.roxFrameCatentryId = Rayban.rcInstance.frameDetails.uniqueID;
        postparams.roxLensCatentryId = Rayban.rcInstance.selectedLensesId;
      }

      $(".add-loader").removeClass("wcs-hide");

		  var postURL = $('#customerSearchURL').val();
		 
       $.ajax({
            type: "POST",
            url: postURL,
            data: postparams
        })
        .done(function(data) {
        	data = JSON.parse(data);
        	$(".add-loader").addClass("wcs-hide");
        	if($("#applePayEnabled") && $("#applePayEnabled").length > 0 && $("#applePayEnabled").val() === 'Y' ) {
    			if(($("#applePayEnabledInPDP") && $("#applePayEnabledInPDP").length > 0 && $("#applePayEnabledInPDP").val() === 'Y')||($("#applePayEnabledInPCP") && $("#applePayEnabledInPCP").length > 0 && $("#applePayEnabledInPCP").val() === 'Y')) {
		        	if(window.applePayDesktopInst !== undefined){
		        		window.applePayDesktopInst.hideApplePayButtons();
		        	}
    			}
    		}
        	if(data.ResultCode === 0){
            $('.eyemed-global-login-bar').removeClass('wcs-hide');
        		if(!data.hasOwnProperty("pricingResponse") || (data.hasOwnProperty("pricingResponse") && data.pricingResponse.pricingResultCode === "0")){
        			if(postparams.pageTypeIns === "PDP"){
        				$(".eyemed-benefits-overlay .wcs-close-btn").trigger('click');
        				if(typeof pdpRoxInst !== "undefined"){
                  pdpRoxInst.makeBenefitPricingCall();
                }else{
                  $.publish('SITE_MAIN_BENEFITPRICINGCALL');
                }
        				 
        			}else{
        				self.hideAndShowWrappers("success");
        			} 
        			Rayban.analytics.promoCodeApplySuccess("Eyemed");
        		}
        		else {
        			if(postparams.pageTypeIns === "PDP"){
        				self.showInsurencePriceError();
        			}else{
                 if(postparams.pageTypeIns === "ShopCart" && data.pricingResponse.pricingResultCode !== "0"){
                    Rayban.analytics.promoCodeApplyError(data.pricingResponse.pricingErrorMessage, "Eyemed", "User");
                 }
        				 self.hideAndShowWrappers("somethingWrongError");
        			}
        		}
        		
        	}
        	else{
        		self.hideAndShowWrappers("serverFormError", data);
            Rayban.analytics.promoCodeApplyError(data.ErrorMessage, "Eyemed");
        	}
        })
        .fail(function(error) {
          $(".add-loader").addClass("wcs-hide");
        	self.hideAndShowWrappers("serverFormError", error);
          Rayban.analytics.promoCodeApplyError(error.status+"-"+error.statusText, "Eyemed");
        });
	};

	this.reloadPage = function(){
		var pageType = $("#pageTypeIns") ? $("#pageTypeIns").val():$("#pgName").val();

		if(pageType === "ShopCart" && !$(".success-message-wrapper").hasClass("wcs-hide")){
			 location.reload();
		}
		else if(pageType === "PDP" && !$(".success-message-wrapper").hasClass("wcs-hide")){
			location.reload();
		}
	};

  this.getCartQuantityCount = function(){
      var qty = 0;
      $(".wcs-shopping-item-qty").each(function(){
            if(!isNaN(parseInt($(this).find(".wcs-shopping-item-qtyCount").text()))) qty = qty + parseInt($(this).find(".wcs-shopping-item-qtyCount").text());
      });

      return qty;
  };

  /*****Check cart count of shop cart and call pricing benefit ajax*****/
	this.check4MultipleItemsInCart = function(){
      var self = this;
      var qty = self.getCartQuantityCount();		 
       
      if((!$.cookie('EyeMedLogin') || $.cookie('EyeMedLogin') === "false") && qty === 1){
         $("#benefits-limit-error").addClass("wcs-hide");
         self.bindEvent();
         $('body').overlayout();
         self.insurancePricingCallFromShopCart(false);
      }
	    else if($.cookie('EyeMedLogin') && $.cookie('EyeMedLogin') === "true" && qty > 1){
	        $("#benefits-limit-error").removeClass("wcs-hide").removeClass("wcs-hidden");
          if($("#invalidInsuranceTopSubTotal").length > 0 && $("#invalidInsuranceTopSubTotal").val() !== "") $("#subTotal").html($("#invalidInsuranceTopSubTotal").val());
	        $("#orderSummary .wcs-checkout-with-container").append("<div class='paypal-disable-wrapper'></div>");
          self.bindEvent();
          $('body').overlayout();
	    }
	    else if($.cookie('EyeMedLogin') && $.cookie('EyeMedLogin') === "true" && qty === 1){
	        self.insurancePricingCallFromShopCart(true);
	    }
      else{
         $('body').overlayout();
      }
	};

	this.insurancePricingCallFromShopCart = function(isEyemed){
    var self = this;
		var ins_remove_link = $(".ins-remove-wrapper").length;
    var userId = $("#wcsUserId").val();

    var pricingUrl  = isEyemed === false ? "RoxInsurancePricing?pageTypeIns=CartPage&isCalculateViewRequired=true&memberId="+userId:"RoxInsurancePricing?pageTypeIns=CartPage&isBenefitPricingRequired=true&isCalculateViewRequired=true&memberId="+userId;

		$.ajax({
            type: "GET",
            url: pricingUrl,
        })
        .done(function(data) {
            $('#mmWrapper').appendTo('.rb-footer')
            document.getElementById("orderSummary").innerHTML = "";
            document.getElementById("orderSummary").innerHTML = data;
            ExposedRayBanApi.injectPayOverTimeComponent('#rb-pay-over-time-container');
            if (window.wcs_config.klarnaExpress.enabled === 'true') {
              ExposedRayBanApi.injectKlarnaExpressComponent('#klarna-express-container');
            }
            if(window.wcs_config.viewTaskName === 'ShopCartDisplayView') {
              if (window.wcs_config.klarnaExpress.enabled === 'true' || window.wcs_config.afterpayExpressEnabled === 'true' || window.wcs_config.ExpPaypal === 'true') {
                  ExposedRayBanApi.injectPaymentMessageBoxComponent('#payment-message-box-container');
              }
            }
            calculate_tax_fn();
            giftcard_bindevents_fn();
            dropscrollerFn();
            select_dropbox_value();
            expand_dropbox();
            collapse_dropbox();
            key_nav_dropdown();
            tax_submit_fn();
            giftcard_bindevents_fn();
            apply_promo_link_click();
            apply_promo_idme_link_click();
            idme_links();
            promo_textbox_focusBlur();
            apply_promotion();
            remove_promotion();
            remove_freeMessage();
            dropscroller_hover_fn();
            self.bindEvent();
            bindShowHideTootip();
            
            var payreload = $("#wcs-page-reload").val();
            var piAmount = $("#piAmount").val();

            if (payreload === "true" && piAmount > 0) {
              $(".pay_with_giftCard").removeClass("wcs-hidden");
            }

            if(isEyemed !== false){
              $("#wcs-apply-promo, #D_CartPage_PromoCode_IDme").addClass("button-disabled");
              if($(".wcs-shopping-item-price .wcs-itemPrice-bag") && $(".wcs-shopping-item-price .wcs-itemPrice-bag").length>0) $(".wcs-shopping-item-price .wcs-itemPrice-bag").html($("#wcs-insurance-price-content").html());
              //else if($(".wcs-shopping-item-price #wcs-price4") && $(".wcs-shopping-item-price #wcs-price4").length>0) $(".wcs-shopping-item-price #wcs-price4").html($("#wcs-insurance-price-content").html());
              $("#subTotal").html($(".wcs-shopping-grandtotal-js").html());
              $("#benefits-limit-error").addClass("wcs-hide");
            if($(".wcs-itemPrice-bag .ins-sp-price").html() === $("#subTotalCalc").html()){
              $(".wcs-shopping-item-price .wcs-itemPrice-bag").html($("#subTotalCalc").html());
            }
             /* if(ins_remove_link === 0){
                Rayban.analytics.promoCodeApplySuccess("Eyemed"); 
              }*/
            }
            
            $('body').overlayout();
            $.publish('RoxPricingCallTriggered');

            $('#mmWrapper').insertBefore('#D_CartPage_PromoCode_Apply')
        })
        .fail(function() {
            $('body').overlayout();
        });
	};

	this.scrollToBenefitError = function(e){
      var self = e.data.self;
      var cartCount = self.getCartQuantityCount();
      var submitID = $(e.currentTarget.innerHTML).attr("id");
      var hrefStr = $(e.currentTarget.innerHTML).attr("href");
      	if(hrefStr != "javascript:void(0)"){
		  	if($("#pageNameVal").val() === "ShopCart"){
		  		if($('.wcs-shipping-mode-left.error-zipcode').length){
		  			event.preventDefault();
		  		}
		  		$('#' + submitID ).attr('disabled','disabled'); 
		  		  $('.wcs-fadeout-full-overlay').show();
		  	}
      	}

      if($.cookie('EyeMedLogin') && $.cookie('EyeMedLogin') === "true" && cartCount !== 1) {
        e.preventDefault();
        $('html,body').animate({
           scrollTop: $("#benefits-limit-error").offset().top
        },'slow');
        if($(e.currentTarget).attr("id")=="wcs-apply-pay"){
        	e.stopPropagation();
        }
      }	       
	};

};

/***Instantiate ROX insurance overlay object on page load****/
$(document).ready(function(){
    window.roxInsuranceOverlayObj = new RoxInsuranceOverlay();
    roxInsuranceOverlayObj.init();
});
